export default __webpack_public_path__ + "static/media/mystery_gift.c018c982.svg";